import { Sparkles, ShieldCheck, Flame, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Empty state card shown when the hero has defeated-or-dismissed every
 * actionable insight for the current dashboard session. Fills the banner slot
 * so it never feels empty and doubles as a soft CTA toward streak check-in /
 * Deploy-Shield re-scan.
 */
export default function AllClearCard({ onRescan, streakDone }) {
  return (
    <div className="mt-6 relative" data-testid="all-clear-card">
      <div className="relative rounded-3xl p-[2px] bg-gradient-to-br from-amber-400 via-yellow-300 to-amber-500 shadow-lg">
        <div className="rounded-[22px] bg-gradient-to-br from-white via-amber-50 to-yellow-50 px-4 py-4">
          <div className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 flex items-center justify-center flex-shrink-0 shadow-md ring-2 ring-amber-300/50">
              <ShieldCheck className="w-5 h-5" strokeWidth={2.8} />
            </div>
            <div className="flex-1 min-w-0">
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-[0.14em] bg-amber-400/20 text-amber-900">
                <Sparkles className="w-3 h-3" strokeWidth={3} />
                All clear
              </span>
              <h3
                className="mt-1 text-base font-black text-slate-900 leading-tight"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Nothing on your radar, hero.
              </h3>
              <p className="mt-0.5 text-[12.5px] leading-snug text-slate-700 font-medium">
                You've handled every insight Dash flagged. {streakDone
                  ? "Rescan with Deploy Shield to surface the next hidden drain."
                  : "Check in this week to stoke your streak, or rescan with Deploy Shield."}
              </p>
            </div>
          </div>
          <div className="mt-3 flex items-center gap-2">
            <Button
              size="sm"
              onClick={onRescan}
              className="h-9 flex-1 rounded-xl bg-slate-900 hover:bg-slate-800 text-amber-400 font-extrabold gap-1.5 px-3"
              data-testid="all-clear-rescan"
            >
              <RefreshCw className="w-4 h-4" strokeWidth={2.8} />
              Rescan with Shield
            </Button>
            <div className="h-9 inline-flex items-center gap-1 px-3 rounded-xl bg-amber-400/20 text-amber-900 font-extrabold text-xs">
              <Flame className="w-3.5 h-3.5" strokeWidth={3} />
              {streakDone ? "Streak locked" : "Streak pending"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
